var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlackEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    clipPath: "url(#clip0_1109_4014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25 3.75L5 0.833328L8.75 3.75V8.33333C8.75 8.55434 8.6622 8.7663 8.50592 8.92258C8.34964 9.07886 8.13768 9.16666 7.91667 9.16666H2.08333C1.86232 9.16666 1.65036 9.07886 1.49408 8.92258C1.3378 8.7663 1.25 8.55434 1.25 8.33333V3.75Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1109_4014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlackEmpty);
export default __webpack_public_path__ + "static/media/home-black-empty.702bc8865b8e0e8b7950123876ddecfd.svg";
export { ForwardRef as ReactComponent };